<template>
    <div v-if="last > 1" class="flex items-center justify-between gap-3 border-t border-nomad-800 px-3 py-2 text-xs text-nomad-200">
        <span>Page {{ page.toLocaleString() }} of {{ last.toLocaleString() }}</span>
        <div class="flex gap-1">
            <button type="button" class="h-7 rounded-md bg-nomad-800 px-2.5 text-white hover:bg-nomad-700 disabled:opacity-40 focus:outline-none focus-visible:ring-2 focus-visible:ring-luuqa"
                :disabled="page <= 1" @click="$emit('go', page - 1)">Previous</button>
            <button type="button" class="h-7 rounded-md bg-nomad-800 px-2.5 text-white hover:bg-nomad-700 disabled:opacity-40 focus:outline-none focus-visible:ring-2 focus-visible:ring-luuqa"
                :disabled="page >= last" @click="$emit('go', page + 1)">Next</button>
        </div>
    </div>
</template>
<script>
export default {
    name: "LuuqaPager",
    props: {
        page: { type: Number, required: true },
        last: { type: Number, required: true },
    },
    emits: ["go"],
};
</script>
